import MessageSimple from './MessageSimple';
import { useMessagesStore } from 'store/modules';

export default class MessageUndo extends MessageSimple {
    constructor(item) {
        super(item);

        this.time = 5000;
        this.currentTime = 0;
        this.progress = 0;
        this.interval = null;
        this.loading = false;
    }

    initInterval = async () => {
        if (this.interval) return;

        let currentTime = 0;
        let progress = 0;
        let interval = true;

        useMessagesStore().updateUndoMessages({
            id: this.conversation.id,
            props: {
                interval: interval,
            },
        });

        interval = setInterval(() => {
            currentTime = currentTime + 1000;
            progress = (currentTime * 100) / this.time;

            if (progress >= 100) {
                this.handleInstantSent('undo');

                clearInterval(this.interval);
            }

            useMessagesStore().updateUndoMessages({
                id: this.conversation.id,
                props: {
                    currentTime: currentTime,
                    progress: progress,
                },
            });
        }, 1000);

        useMessagesStore().updateUndoMessages({
            id: this.conversation.id,
            props: {
                interval: interval,
            },
        });
    };

    handleUndo = () => {
        clearInterval(this.interval);
        useMessagesStore().deleteUndoMessages(this);
    };

    handleInstantSent = async (type = 'default') => {
        if (this.loading) return;

        clearInterval(this.interval);

        await useMessagesStore().updateUndoMessages({
            id: this.conversation.id,
            props: {
                loading: true,
            },
        });

        await this.handleSendMessage(this.conversation, this.form, type);
        await useMessagesStore().deleteUndoMessages(this);
        await this.delay(500);
    };

    handleClose = () => {
        clearInterval(this.interval);
        useMessagesStore().deleteUndoMessages(this);
    };

    delay = (time = 1000) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                return resolve();
            }, time);
        });
    };
}
